import { Modal } from "antd";
import { Flex } from "@chakra-ui/layout";
import Heading from "ui/components/text/heading";
import { TagModalCadastroIncompleto } from "./TagModalCadastroIncompleto/index";
import OutlineButton from "ui/components/Button/OutlineButton";
import { TenantPassoCadastroResponse } from "./../../typings/header.data";
import history from "infra/helpers/history";
import { useCurrentTenant } from "core/features/auth/tenant.store";

interface ModalCadastroIncompletoProps {
  isOpen: boolean;
  onClose: () => any;
  data: TenantPassoCadastroResponse | undefined;
}

const rotas: (tenantId: string) => Record<string, string> = (tenantId) => ({
  "Responsáveis Legais": "/usuarios",
  "Plano de Contas": `/meu-condominio/${tenantId}?opcao=plano_de_contas`,
  "Contas Bancárias": `/meu-condominio/${tenantId}?opcao=contas_bancarias`,
  Unidades: "/cadastros/unidades",
});

export function ModalCadastroIncompleto({
  isOpen,
  onClose,
  data,
}: ModalCadastroIncompletoProps) {
  const { tenant } = useCurrentTenant();

  return (
    <Modal visible={isOpen} onCancel={onClose} footer={null}>
      <Heading mb={4} fontWeight="bold" size="14px" fontSize="18px">
        Complete seu cadastro
      </Heading>

      <Flex flexDirection="column" gap="12px" mt={10}>
        {data?.map((value) => (
          <TagModalCadastroIncompleto
            isCheck={value.porcentagemConcluido < 100 ? true : false}
            labelTop={value.nome}
            labelBot={value.descricao || ""}
            handleCompletar={() => {
              onClose();
              history.push(`${rotas(tenant.id)[value.nome]}`);
            }}
          />
        ))}
      </Flex>
      <Flex flex={1} justifyContent="end" mt="40px">
        <OutlineButton onClick={() => onClose()}>Fechar</OutlineButton>
      </Flex>
    </Modal>
  );
}
